import { useMemo } from 'react';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { CALLING_EXTENSIONS_CLICK_TO_CALL_MIGRATION } from 'calling-internal-common/constants/CallingGates';
export const initialState = {
  isUngatedForExtensionsInboundCalling: false,
  isRemoteEnabled: false,
  isUngatedForClickToCallMigration: false
};
export function useThirdPartyGates() {
  const {
    gates
  } = useUserInfo();
  const {
    isRemoteEnabled
  } = useSelectedProviderContext();
  const isUngatedForExtensionsInboundCalling = useMemo(() => {
    return true;
  }, []);
  const isUngatedForClickToCallMigration = useMemo(() => {
    return gates.includes(CALLING_EXTENSIONS_CLICK_TO_CALL_MIGRATION);
  }, [gates]);
  return {
    isUngatedForExtensionsInboundCalling,
    isRemoteEnabled,
    isUngatedForClickToCallMigration
  };
}